import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const InfoCard = styled.div`
  &:nth-child(odd) {
    flex-direction: row-reverse;
  }
`;

const CourseImage = styled(GatsbyImage)`

`;

const S = {
    InfoCard,
    CourseImage
};

export default S;
